import './About.scss';

function About() {
  return (
    <main className="about">
      <h1>About SF Dreamer</h1>
      <div className="container">
        <p>Have you ever felt like you don't belong?</p>
        <p>You're not alone!</p>
        <p>
          There are more than 3 million other Dreamers like you that have lived in the U.S. since their childhood, but still fear that
          there's no help for them. Back in 2019, a group of interns from Dev/Mission strongly believed that could make an impact in
          people's lives by gathering information, resources, and support that could help immigrant students like you pursue a higher
          education or even a possible employment option regardless of your immigration status.
        </p>
        <p>
          This website was created from scratch by other dreamers like you and with the help of other volunteers that work at different tech
          companies. As you may notice, this is a website that needs more work to be done, but we strongly believe that we can make an
          impact in people's lives with the information provided.
        </p>
      </div>
    </main>
  );
}

export default About;
